export const DRAFT_TUTORIAL_STORAGE_KEY = 'dataunfold:dag-draft-tutorial-dismissed';
export const DRAFT_TUTORIAL_RESET_EVENT = 'dataunfold:dag-draft-tutorial-reset';

export const isDraftTutorialDismissed = () => {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(DRAFT_TUTORIAL_STORAGE_KEY) === 'true';
  } catch (_error) {
    return false;
  }
};

export const dismissDraftTutorial = () => {
  if (typeof window === 'undefined') return false;

  try {
    window.localStorage.setItem(DRAFT_TUTORIAL_STORAGE_KEY, 'true');
    return true;
  } catch (_error) {
    return false;
  }
};

export const resetDraftTutorial = () => {
  if (typeof window === 'undefined') return false;

  try {
    window.localStorage.removeItem(DRAFT_TUTORIAL_STORAGE_KEY);
    window.dispatchEvent(new Event(DRAFT_TUTORIAL_RESET_EVENT));
    return true;
  } catch (_error) {
    return false;
  }
};
